import type { IconNode } from '../types';

/**
 * @name bee
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtOCAyIDEuODggMS44OCIgLz4KICA8cGF0aCBkPSJNMTQuMTIgMy44OCAxNiAyIiAvPgogIDxwYXRoIGQ9Ik05IDdWNmEzIDMgMCAxIDEgNiAwdjEiIC8+CiAgPHBhdGggZD0iTTUgN2EzIDMgMCAxIDAgMi4yIDUuMUM5LjEgMTAgMTIgNyAxMiA3czIuOSAzIDQuOCA1LjFBMyAzIDAgMSAwIDE5IDdaIiAvPgogIDxwYXRoIGQ9Ik03LjU2IDEyaDguODciIC8+CiAgPHBhdGggZD0iTTcuNSAxN2g5IiAvPgogIDxwYXRoIGQ9Ik0xNS41IDEwLjdjLjkuOSAxLjQgMi4xIDEuNSAzLjMgMCA1LjgtNSA4LTUgOHMtNS0yLjItNS04Yy4xLTEuMi42LTIuNCAxLjUtMy4zIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/bee
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const bee: IconNode = [
  ['path', { d: 'm8 2 1.88 1.88', key: 'fmnt4t' }],
  ['path', { d: 'M14.12 3.88 16 2', key: 'qol33r' }],
  ['path', { d: 'M9 7V6a3 3 0 1 1 6 0v1', key: 'ygny09' }],
  [
    'path',
    { d: 'M5 7a3 3 0 1 0 2.2 5.1C9.1 10 12 7 12 7s2.9 3 4.8 5.1A3 3 0 1 0 19 7Z', key: 'alnxb1' },
  ],
  ['path', { d: 'M7.56 12h8.87', key: 'zy8tq7' }],
  ['path', { d: 'M7.5 17h9', key: '12rbth' }],
  [
    'path',
    {
      d: 'M15.5 10.7c.9.9 1.4 2.1 1.5 3.3 0 5.8-5 8-5 8s-5-2.2-5-8c.1-1.2.6-2.4 1.5-3.3',
      key: '1x6v6g',
    },
  ],
];

export default bee;
